// extracted by mini-css-extract-plugin
var _1 = "BALogo__blue--qdPu4";
var _2 = "BALogo__cyan--J2oZx";
var _3 = "BALogo__red--nVewB";
var _4 = "BALogo__transparentGray--FiF_t";
var _5 = "BALogo__white--JJiCN";
var _6 = "BALogo__yellow--IMwVU";
export { _1 as "blue", _2 as "cyan", _3 as "red", _4 as "transparentGray", _5 as "white", _6 as "yellow" }
